import { createSlice } from '@reduxjs/toolkit';

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    users: [],
    stores: [],
    userStoreRights: [],
    userTypes: [],
  },
  reducers: {
    setAdminData(state, action) {
      const { users, stores, userStoreRights, userTypes } = action.payload;
      if (users) state.users = users;
      if (stores) state.stores = stores;
      if (userStoreRights) state.userStoreRights = userStoreRights;
      if (userTypes) state.userTypes = userTypes;
    },
    addUser(state, action) {
      state.users.push(action.payload);
    },
    updateUser(state, action) {
      const idx = state.users.findIndex(u => u.id === action.payload.id);
      if (idx >= 0) state.users[idx] = { ...state.users[idx], ...action.payload };
    },
    removeUser(state, action) {
      state.users = state.users.filter(u => u.id !== action.payload);
      state.userStoreRights = state.userStoreRights.filter(r => r.userId !== action.payload);
    },
    addStore(state, action) {
      state.stores.push(action.payload);
    },
    updateStore(state, action) {
      const idx = state.stores.findIndex(s => s.id === action.payload.id);
      if (idx >= 0) state.stores[idx] = { ...state.stores[idx], ...action.payload };
    },
    removeStore(state, action) {
      state.stores = state.stores.filter(s => s.id !== action.payload);
      state.userStoreRights = state.userStoreRights.filter(r => r.storeId !== action.payload);
    },
    setUserStoreRight(state, action) {
      const { userId, storeId, ...rights } = action.payload;
      const idx = state.userStoreRights.findIndex(r => r.userId === userId && r.storeId === storeId);
      if (idx >= 0) {
        state.userStoreRights[idx] = { ...state.userStoreRights[idx], ...rights };
      } else {
        state.userStoreRights.push({ userId, storeId, canView: false, canGenerate: false, canPrint: false, canManage: false, ...rights });
      }
    },
    removeUserStoreRight(state, action) {
      const { userId, storeId } = action.payload;
      state.userStoreRights = state.userStoreRights.filter(r => !(r.userId === userId && r.storeId === storeId));
    },
  },
});

export const { setAdminData, addUser, updateUser, removeUser, addStore, updateStore, removeStore, setUserStoreRight, removeUserStoreRight } = adminSlice.actions;
export default adminSlice.reducer;
